// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1Z2Dl","list":"BalanceDue_list__3VOR6","listRow":"BalanceDue_listRow__3SMid","total":"BalanceDue_total__3qpK6"};